import { useState } from "react";
import { Dropdown } from "react-bootstrap";

export function TrainerDropdown({ id, trainers, onUpdate }) {

  const defaultIndex = trainers.findIndex((l) => l.id == id);
  const defaultLocation = defaultIndex == -1 ? null : trainers[defaultIndex];
  const [currentTrainer, setCurrentTrainer] = useState(defaultLocation);

  function onLocationUpdate(index) {
    setCurrentTrainer(trainers[index]);
    onUpdate(trainers[index]);
  }

  return (
    <Dropdown key={`trainers_dropdown_container`} drop="end">
      <Dropdown.Toggle variant="success" id="dropdown-basic">
        {currentTrainer == null ? "Trainer" : currentTrainer.name}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {
          trainers.length > 0
            ? trainers.map(function (item, index) {
              return <Dropdown.Item
                key={`trainers.${index}_trainer_drop_down_menu`}
                onClick={() => onLocationUpdate(index)}
                name={item.name}>
                {item.name} ({item.role})
              </Dropdown.Item>;
            })
            : <></>
        }
      </Dropdown.Menu>
    </Dropdown>
  );
}